import React, { useState }  from 'react'
import axios from 'axios'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Car1 from '../../images/car1.png'
import Car2 from '../../images/car2.png'
import Car3 from '../../images/car3.png'
import { MdKeyboardArrowRight,MdKeyboardArrowDown } from 'react-icons/md'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function BookDemoDriveSimple() {
  const [msg, setMsg] = useState('')
  const [err, setErr] = useState('')
  const [storeName, setStoreName] = useState('')
  const [vehicleName, setVehicleName] = useState('')
  const [date, setDate] = useState('')
  const [time, setTime] = useState('')
  const [reservation_data1, setReservation_data1] = useState([])
  const [reservationStart, setReservationStart] = useState('')
  const [reservationEnd, setReservationEnd] = useState('')
  const [schedule, setSchedule] = useState([])
  const [scheduleDisplay,setScheduleDisplay] = useState(false)
  const [slotDisplay,setSlotDisplay] = useState(false)
    function join(date, options, separator) {
      function format(option) {
          let formatter = new Intl.DateTimeFormat('en', option)
          return formatter.format(date)
      }
      return options.map(format).join(separator)
    }   
    function isEmpty(x) {
      for (const prop in x) {
        if (Object.hasOwn(x, prop)) {
          return false;
        }
      }
      return true;
    }
    const onClick2CreateScheduleMenu = async()=>{
      setMsg('')
      setErr('')
      setStoreName('')
      setVehicleName('')
      setDate('')
      setTime('')
      try {
        const { data: res } = await axios.get(`${APIURL}/basic/book-demo-drive1`)
        setReservation_data1(res.info)
      } catch (err) {
        console.log(err)
      }
      setScheduleDisplay(true)
    }
    const onChange2StoreName = (x1) => { 
      setStoreName(x1)
      setVehicleName('')
      setDate('')
      setTime('')
      const reservation_start = reservation_data1.filter(x=>x.title==x1)[0].reservation_start
      const reservation_end = reservation_data1.filter(x=>x.title==x1)[0].reservation_end
      setReservationStart(reservation_start)
      setReservationEnd(reservation_end)
      const cars = reservation_data1.filter(x=>x.title==x1)[0].demo_drive[0].car.map(x=>x.name)
      let reservation_timesheet1 = {}
      for(let i1=0;i1<cars.length;i1++){
        const reservation_timesheet2 = {}
        let last_date = false
        let i2 = 0
        while(!last_date){
          const timestamp = new Date(`${reservation_start.slice(5,7)}/${reservation_start.slice(8,10)}/${reservation_start.slice(0,4)}`).getTime()+(1000*60*60*24*i2)
          const format = join(new Date(timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
          if(format==reservation_end){
            last_date = true
          }else{
            i2++
          }
          reservation_timesheet2[`${format}`] = [{"10.00-10.30":"F"},{"11.00-11.30":"F"},{"12.00-12.30":"F"},{"13.00-13.30":"F"},{"14.00-14.30":"F"},{"15.00-15.30":"F"},{"16.00-16.30":"F"},{"17.00-17.30":"F"}]
        }         
        let reservation_data2 = ''
        let x2 = reservation_data1.filter(x=>x.title==x1)[0].demo_drive[0].car.filter(x=>x.name==cars[i1])[0].reservation
        if(!isEmpty(x2)){
          reservation_data2 =x2
          for(let i3 = 0; i3<Object.keys(reservation_data2).length;i3++){
            let dataset = [{"10.00-10.30":"F"},{"11.00-11.30":"F"},{"12.00-12.30":"F"},{"13.00-13.30":"F"},{"14.00-14.30":"F"},{"15.00-15.30":"F"},{"16.00-16.30":"F"},{"17.00-17.30":"F"}]
            for(let i4 = 0; i4<Object.values(reservation_data2)[i3].length;i4++){
              const x3 = Object.keys(Object.values(reservation_data2)[i3][i4])[0]
              switch (x3) {
                case '10.00-10.30':
                  dataset[0]={"10.00-10.30":"T"}
                  break
                case '11.00-11.30':
                  dataset[1]={"11.00-11.30":"T"}
                  break
                case '12.00-12.30':
                  dataset[2]={"12.00-12.30":"T"}
                  break
                  case '13.00-13.30':
                  dataset[3]={"13.00-13.30":"T"}
                  break
                case '14.00-14.30':
                  dataset[4]={"14.00-14.30":"T"}
                  break
                case '15.00-15.30':
                  dataset[5]={"15.00-15.30":"T"}
                  break
                case '16.00-16.30':
                  dataset[6]={"16.00-16.30":"T"}
                  break
                case '17.00-17.30':
                  dataset[7]={"17.00-17.30":"T"}
                  break
                default:
                  console.log('out of regular slot')
              }
            }
            reservation_timesheet2[Object.keys(reservation_data2)[i3]]=dataset
          }
        }else{
          console.log('no reservation')
        }
      reservation_timesheet1[cars[i1]] = reservation_timesheet2
      }
      setSchedule(reservation_timesheet1)
      
    }
    const onChange2VehicleName = (x1) => { 
      setVehicleName(x1)
      setDate('')
      setTime('')
    }
    const onChange2Date = (e) => { 
      setDate(e.target.value)
      setTime('')
    } 
    const onClick2CloseBookInterview = async()=>{
      setErr('')
      setMsg('')
      setScheduleDisplay(false)
    }
    const onClick2Submit = async()=>{
      setErr('')
      setMsg('')
      const date_timestamp = new Date(`${date.slice(5,7)}/${date.slice(8,10)}/${date.slice(0,4)}`).getTime()
      if(storeName==''){
        setErr('Please select store name.')
      }else if(vehicleName==''){
        setErr('Please select vehicle name.')
      }else if(date==''){
        setErr('Please input reservation date.')
      }else if(time==''){
        setErr('Please select reservation time.')
      }else{
        let x2 = reservation_data1.filter(x=>x.title==storeName)[0].demo_drive[0].car.filter(x=>x.name==vehicleName)[0].reservation
        if(!isEmpty(x2)){
          let format = schedule[vehicleName][`${date}`]
          let a2 = {}
          a2[`${time}`]="T"
          format[format.findIndex((x) => Object.keys(x) == time)]=a2
          reservation_data1.filter(x=>x.title==storeName)[0].demo_drive[0].car.filter(x=>x.name==vehicleName)[0].reservation[`${date}`]=format.filter((x)=>Object.values(x)!="F")
        }else{
          let a1 = []
          let a2 ={}
          a2[`${time}`] = "T"
          a1.push(a2)
          reservation_data1.filter(x=>x.title==storeName)[0].demo_drive[0].car.filter(x=>x.name==vehicleName)[0].reservation[`${date}`]=a1
        }
        function timeConverter(x){
          return new Date(`${x.slice(5,7)}/${x.slice(8,10)}/${x.slice(0,4)}`).getTime()
        }
        const reservation_update = Object.fromEntries(Object.entries(reservation_data1.filter(x=>x.title==storeName)[0].demo_drive[0].car.filter(x=>x.name==vehicleName)[0].reservation).sort((a, b) => {
          return timeConverter(a[0]) - timeConverter(b[0])
        }))
        let a3 = reservation_data1.findIndex(x=>x.title==storeName)
        let a4 = reservation_data1[a3].demo_drive[0].car.findIndex(x=>x.name==vehicleName)
        reservation_data1[a3].demo_drive[0].car[a4].reservation = reservation_update
        try {
          const { data: res } = await axios.post(`${APIURL}/basic/book-demo-drive1`,{'reservation_data':reservation_data1})
        } catch (err) {
          console.log(err)
        }
        setMsg(`You are successfully booked. Your demo drive is on ${new Date(date_timestamp).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} at ${time.toString().slice(0,5)}.`)
        setScheduleDisplay(false)
      }
    }
    return (
      <div>
      <button className='text-xs primary-btn w-fit mb-1' onClick={onClick2CreateScheduleMenu} disabled={scheduleDisplay}>Set demo drive time</button>
      {scheduleDisplay?<>
      <div className='flex mt-4'>
        <FormControl  sx={{ mr:1, width: 120, fontSize:14 }} size='small'>
        <InputLabel  sx={{ fontSize:12 }}>Store</InputLabel>
        <Select
          value={storeName}
          label='store_name'
          onChange={(e)=>onChange2StoreName(e.target.value)}
          sx={{ fontSize:9, borderRadius: 0 }}
        >
          {reservation_data1.map((x)=><MenuItem value={x.title} sx={{fontSize:9}}>{x.title}</MenuItem>)}
        </Select>
      </FormControl>
      {storeName!=''?
      <FormControl  sx={{ mr:1, width: 120, fontSize:14 }} size='small'>
          <InputLabel  sx={{ fontSize:12 }}>Vehicle</InputLabel>
          <Select
            value={vehicleName}
            label='store_name'
            onChange={(e)=>onChange2VehicleName(e.target.value)} 
            sx={{ fontSize:9, borderRadius: 0 }}
          >
            {reservation_data1.filter((x)=>x.title == storeName)[0].demo_drive[0].car.map(x=><MenuItem value={x.name} sx={{fontSize:9}}>{x.name}</MenuItem>)}
          </Select>
        </FormControl>
      : <FormControl  sx={{ mr:1, width: 120, fontSize:14 }} size='small'>
      <InputLabel sx={{ fontSize:12 }}>Vehicle</InputLabel>
      <Select
        value={storeName}
        label='store_name'
        onChange={(e)=>onChange2VehicleName(e.target.value)} 
        sx={{ fontSize:9, borderRadius: 0 }}
      >
      </Select>
    </FormControl>} 
      <input type='date' name='reservation_date' value={date} 
      min={reservationStart} max={reservationEnd}
      onChange={(x)=>onChange2Date(x)} 
      className={`${err!=''&& date==''?'border-red-600':'border-[#cbcbcb]'} pr-2 pl-2 text-[9px] border w-fit mr-1 mt-auto h-[30px]`}/>
      </div>
      {err!='' ? <span className='text-xs text-red-700'>{err}</span>:''} 
      {storeName!=''?<><div className='cursor-default flex text-[8px]' onClick={(()=> setSlotDisplay(!slotDisplay))}>See all available time at {storeName} {slotDisplay?<MdKeyboardArrowDown className='mt-auto mb-auto'/>:<MdKeyboardArrowRight className='mt-auto mb-auto' />}</div>
      {slotDisplay?<>
      {Object.keys(schedule).map(x1=>
      <>
      <div className='text-[8px]'><span className='w-fit mr-2'>{x1}</span></div> 
      {Object.keys(schedule[x1]).map(x2=><div className='flex text-[8px]'><span className='w-[72px] mr-2'>{x2}</span>
      {Object.values(schedule[x1][x2]).map(x3=><>{Object.values(x3)!='T'?<span className='mr-2 w-[68px]'>
      {Object.keys(x3)}</span>:''}</>)}
      </div>)}
      </>
      )}
      </>:''}
      </>:''}
      {storeName!='' && vehicleName!=''&& date!=''?<div className='flex mt-4'>
      <div className='flex flex-col text-xs'>
      {schedule[vehicleName][date].map(x2=>Object.values(x2)).join('').includes('F')?'':<span className='text-xs text-red-700'>All booked for this day. Try another date.</span>}
      {schedule[vehicleName][date].map(x2=><>{Object.values(x2)!='T'?<div className='mt-1 mb-1'><input type='radio' id={Object.keys(x2)} name={date} value='T' onChange={()=>setTime(Object.keys(x2)[0])}/> <span className={`${err!=''&& time==''?'text-red-600':''}`}>{Object.keys(x2)}</span><br/></div>:''}</>)}
      </div>
      <div className='relative w-[500px] h-[180px]'>
        <img src={`${vehicleName=='CAR A'?Car1:vehicleName=='CAR B'?Car2:Car3}`} className='car w-[270px]'/>
      </div>
      </div>:''}
      <div className='flex mb-4'><button className='primary-btn text-xs w-fit mt-1 mr-1' onClick={onClick2CloseBookInterview}>Cancel</button><button className='primary-btn text-xs w-fit mt-1' onClick={onClick2Submit}>Submit</button></div>
       </>:''}
      {msg!='' ? <>
      <span className='text-xs'>{msg}</span><br/>
      </>:''}
      </div>
    )
  }